import React from 'react'
import { Button, Text, View } from 'oio-react'
import AnnouncementIcon from 'src/custom/gns3/icons/announcement'
import { useOrganization } from 'src/graphql/hooks'

const AnnouncementBanner = () => {
   const { organization } = useOrganization()
   const announcementEnabled = organization.metadata.find(m => m.key === 'announcement_enabled')?.value

   const announcementButtonName = organization.metadata.find(m => m.key === 'announcement_button_name')?.value

   const announcementMessage = organization.metadata.find(m => m.key === 'announcement_message')?.value

   const announcementUrl = organization.metadata
      .find(m => m.key === 'announcement_url')?.value

   // // Note this value is a string since it is a metadata value
   if (announcementEnabled !== 'true') {
      return null
   }

   return (
      <a href={announcementUrl} target="_blank" rel="noopener noreferrer">
         <View
            display="flex"
            alignItems="center"
            backgroundColor="#fffaec"
            padding="15px 20px"
            marginBottom="20px"
            borderRadius="3px">
            <AnnouncementIcon width="16px" height="16px" color="orange" />
            <View flex="1 1 auto" padding="0px 10px">
               <Text size="2" color="#4f402f" weight="medium">
                  {announcementMessage}
               </Text>
            </View>
            <Button
               name={announcementButtonName || 'Get it now!'}
               color="orange"
            />
         </View>
      </a>
   )
}

export default AnnouncementBanner
